// @ts-strict-ignore
import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  Button,
  Box as Column,
  Box as FilterDownload,
  Icon,
  Box as OuterWrapper,
} from '@node-space/ui-components'
import { useFeatureFlags } from 'hooks/useFeatureFlags'
import FilterResetList from './components/Filters/FilterResetList'
import FilterSearch from './components/Filters/FilterSearch'
import FilterModal from './components/Modal/FilterModal'
import type { FilterBarType } from './types'

const FilterBar = ({
  eventHandlers,
  isChannel = false,
  isChannelManagement = false,
  conditions: { isExportingCSV = false },
  filterDateRange,
  searchInputPlaceholder,
  children,
}: FilterBarType) => {
  const { t } = useTranslation()
  const { enablePaymentsExport, enablePaymentsCsvExport } = useFeatureFlags()

  return (
    <>
      <OuterWrapper
        testId="filter-bar-component"
        flex
        justify="between"
        className={'flex-col lg:flex-row gap-3'}
      >
        <Column className="block w-full">
          {children || <FilterSearch placeholder={searchInputPlaceholder} />}
        </Column>
        <Column className="item flex gap-3 mt-4 lg:mt-0">
          <FilterModal
            eventHandlers={eventHandlers}
            isChannel={isChannel}
            filterDateRange={filterDateRange}
            isChannelManagement={isChannelManagement}
          />
          {(enablePaymentsExport || enablePaymentsCsvExport) && !isChannelManagement && (
            <FilterDownload>
              <Button
                variant="secondary"
                {...(!isExportingCSV && { iconElement: <Icon name="DownloadSimple" /> })}
                onClick={eventHandlers?.handleExportClicked}
                disabled={isExportingCSV}
                testId="filter-bar-download-csv-btn"
              >
                {!isExportingCSV ? t('export') : `${t('loading')}...`}
              </Button>
            </FilterDownload>
          )}
        </Column>
      </OuterWrapper>
      <FilterResetList executor={eventHandlers?.executor} />
    </>
  )
}

export default FilterBar
